export function getTreasureMapPermissions({ level = 0, canManageLocations = false } = {}) {
  const numericLevel = Number(level || 0);
  const canAddLocation = numericLevel >= 5 || Boolean(canManageLocations);

  return {
    canAddLocation,
    canOpenAddDrawer: canAddLocation,
    canManageLocations: Boolean(canManageLocations),
    needsLevelFiveHint: !canAddLocation,
  };
}

export default getTreasureMapPermissions;
